<label class="ap-file">
    <ap-button
        class="ap-width-100"
        [variant]="variant()"
        [compact]="compact()"
        [isDisabled]="isDisabled()"
        type="button"
        (onClick)="selectFiles()"
    >
        {{ label() }}
    </ap-button>
    <input
        #fileInput
        type="file"
        [attr.disabled]="isDisabled() ? isDisabled() : null"
        [attr.aria-invalid]="control ? control.invalid : null"
        [attr.value]="files"
        [(ngModel)]="files"
        (change)="onInputChange($event)"
        [accept]="accept()"
        [multiple]="allowMultiple()"
    />
</label>
